const randId = () => {
    return (Math.random() + Date.now())
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .toUpperCase();
};

export default randId;
